import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TabPanel from "../../../components/UI/tabPanel";
import { a11yProps } from "../../../utils/common";
import RequestsTab from "./requestsTab";
import WhitelistTab from "./whitelistTab";

const WhitleListing = () => {
  const location = useLocation();
  const activeTab: any = location?.search?.split("=")[1];
  const [value, setValue] = React.useState(Number(activeTab - 1));
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const navigate = useNavigate();
  const generateWhitelistingRoute = (index: number) => {
    return `/settings/whitelisting?tab=${index}`;
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Requests"
            {...a11yProps(0)}
            onClick={() => navigate(generateWhitelistingRoute(1))}
          />
          <Tab
            label="Whitelist"
            {...a11yProps(1)}
            onClick={() => navigate(generateWhitelistingRoute(2))}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <RequestsTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <WhitelistTab />
      </TabPanel>
    </Box>
  );
};

export default WhitleListing;
